export const parse = (text, reviver?) => {
  let result
  try {
    result = JSON.parse(text, reviver)
  } catch (error) {
    return null
  }
  return result
}

export const stringify = (obj: unknown) => {
  try {
    return JSON.stringify(obj)
  } catch (error) {
    return null
  }
}
